import { HStack, Stack, VStack } from "@chakra-ui/react"
import { Text } from "@/components"
import { useResources } from "@/hooks"
import { Resource } from "@/types"
import { ResourceGridItem, ResourceListItem } from "./components"

export const ResourcesComponent = () => {
  const { data: resources } = useResources()

  return (
    <VStack>
      <VStack pt={10} pb={10} bg="gray.100" w="100%">
        <Text fontSize={{ base: "3xl", md: "5xl" }} fontWeight="bold">
          Helpful Resources
        </Text>
        <Text fontSize="md" color="gray.500">
          A curated list of resources to help you navigate your ESO journey
        </Text>
      </VStack>
      <Stack direction={{ base: "column", md: "row" }} px={{ base: 4, md: 20 }} pt={10} w="100%" gap={10}>
        {
          resources && resources.length > 2 && (
            resources.slice(0, 2).map((resource: Resource, index: number) => (
              <ResourceGridItem key={index} resource={resource} />
            ))
          )
        }
      </Stack>
      <Stack px={{ base: 4, md: 20 }} pt={10} pb={10} w="100%" gap={5}>
        {
          resources.slice(2).map((resource: Resource, index: number) => {
            return (
              <ResourceListItem key={index} resource={resource} />
            )
          })
        }
      </Stack>
    </VStack>
  )
}
